import React from 'react';

import BannerCard from '../BannerCard/BannerCard';

const NoResultsFound = () => {
  return <BannerCard text="No property found for your search criteria. Please reset filters." />;
};

export default NoResultsFound;
